import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=3376624a&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=ts"
export * from "./PageHeader.vue?vue&type=script&lang=ts"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=3376624a&prod&lang=css"
import style1 from "./PageHeader.vue?vue&type=style&index=1&id=3376624a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3376624a",
  null
  
)

export default component.exports